import { render, staticRenderFns } from "./PowerCodeExplainerView.vue?vue&type=template&id=1ab2157c&scoped=true"
import script from "./PowerCodeExplainerView.vue?vue&type=script&lang=js"
export * from "./PowerCodeExplainerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2157c",
  null
  
)

export default component.exports